import React from 'react';

interface Props {
  value: boolean;
}

export default function SellingBadge({ value }: Props) {
  const selling = !!value;

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
      padding: '2px 8px',
      borderRadius: 12,
      fontSize: 12,
      fontWeight: 500,
      color: selling ? '#15803d' : '#6b7280',
      background: selling ? '#dcfce7' : '#f3f4f6',
    }}>
      <span style={{
        width: 6,
        height: 6,
        borderRadius: '50%',
        background: selling ? '#22c55e' : '#9ca3af',
      }} />
      {selling ? 'Selling' : 'Not Selling'}
    </span>
  );
}
